/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * User's geographic location
 * @export
 * @interface V1AuthMePayloadLocation
 */
export interface V1AuthMePayloadLocation {
    /**
     * Longitude coordinate
     */
    lon?: number
    /**
     * Latitude coordinate
     */
    lat?: number
}

/**
 * Check if a given object implements the V1AuthMePayloadLocation interface.
 */
export function instanceOfV1AuthMePayloadLocation(
    value: object
): value is V1AuthMePayloadLocation {
    return true
}

export function V1AuthMePayloadLocationFromJSON(
    json: any
): V1AuthMePayloadLocation {
    return V1AuthMePayloadLocationFromJSONTyped(json, false)
}

export function V1AuthMePayloadLocationFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1AuthMePayloadLocation {
    if (json == null) {
        return json
    }
    return {
        lon: json['lon'] == null ? undefined : json['lon'],
        lat: json['lat'] == null ? undefined : json['lat']
    }
}

export function V1AuthMePayloadLocationToJSON(
    json: any
): V1AuthMePayloadLocation {
    return V1AuthMePayloadLocationToJSONTyped(json, false)
}

export function V1AuthMePayloadLocationToJSONTyped(
    value?: V1AuthMePayloadLocation | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        lon: value['lon'],
        lat: value['lat']
    }
}
